import { $ } from '../vendors/jquery';

const setPageMinHeight = {
    init() {
        //Page min height handler
        function setMainMinHeight() {
            const $main   = $('main');
            const $footer = $('footer');

            if (!$main.length || !$footer.length) return;

            // Viewport height
            const viewportH = window.innerHeight || $(window).height();

            // Heights of optional elements
            let $header = $('header:not(.brx-sticky)');
            if( !$header.length ) {
                $header = $('header.brx-sticky.on-scroll');
            }

            let headerH = 0;
            if( typeof $header !== 'undefined' && $header.length > 0 ) {
                headerH   = $header.first().outerHeight(true) || 0;
            }

            const ctaH      = $('.footer-cta').first().outerHeight(true) || 0;
            const adminbarH = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0;

            // Current main height
            const mainH = $main.outerHeight(true) || 0;

            // Calculate how much space footer should fill
            const minFooterH = Math.max(0, viewportH - (headerH + ctaH + adminbarH + mainH));

            $footer.css({
                'min-height': minFooterH + 'px',
                'display': 'flex',
                'flex-direction': 'column',
            });
        }

        //Page min height;
        setMainMinHeight();
    }
};

export default setPageMinHeight;
